(function ($) {
    'use strict';

    if (window.location.href.indexOf('thank-you') === -1) {
        // only run this on the thank you page
        return;
    }

    $(window).load(async function () {
        if (!window.purchase.hasMadePurchase()) {
            console.log(
                'THANK_YOU: Purchase already tracked, redirecting to my account'
            );
            // no purchase recorded, or it has already been dealt with, redirect
            window.location.href = '/my-account/overview';
            return;
        }

        console.log('THANK_YOU: Items purchased:', window.purchase.items);

        const totalPriceEl = document.querySelector('#total-price');
        const firstNameEl = document.querySelector('.kl-js-fn');
        const lastNameEl = document.querySelector('.kl-js-ln');
        const emailEl = document.querySelector('.kl-js-email');
        const phoneEl = document.querySelector('.kl-js-phone');
        const addressEl = document.querySelector('.kl-js-address');
        const productNameEl = document.querySelector('.kl-js-product-name');
        const productPriceEl = document.querySelector('.kl-js-product-price');
        const productIntervalEl = document.querySelector('.kl-js-product-interval');
        const productImageEl = document.querySelector('.kl-js-product-image-src');

        let finalTotal = window.purchase.checkout.total;

        // Fill in product details from the first purchased item
        if (window.purchase.items.length > 0) {
            const firstItem = window.purchase.items[0];
            const product = firstItem.getProduct();

            if (productNameEl) {
                productNameEl.textContent = product.name;
            }
            if (productPriceEl) {
                productPriceEl.textContent = '£' + product.price.toFixed(2);
            }
            if (productIntervalEl) {
                if (product.subscription_length) {
                    productIntervalEl.textContent = '£' + product.price.toFixed(2) + ' /' + product.subscription_length;
                } else {
                    productIntervalEl.textContent = 'One-off purchase';
                }
            }
            if (productImageEl && product.imageUrl) {
                productImageEl.src = product.imageUrl;
                productImageEl.style.display = 'block';
            }
        }

        // Fill in total price
        if (totalPriceEl) {
            totalPriceEl.textContent = '£' + finalTotal.toFixed(2);
        }

        // Fill in user information in the Shipping Address section
        if (firstNameEl) {
            firstNameEl.textContent =
                window.purchase.checkout.billing.first_name;
        }
        if (lastNameEl) {
            lastNameEl.textContent = window.purchase.checkout.billing.last_name;
        }
        if (emailEl) {
            emailEl.textContent = window.purchase.checkout.email;
        }
        if (phoneEl) {
            phoneEl.textContent = window.purchase.checkout.phone;
        }
        if (addressEl) {
            addressEl.textContent = `${window.purchase.checkout.billing.address}, ${window.purchase.checkout.billing.city}, ${window.purchase.checkout.billing.zip}, United Kingdom`;
        }

        // Send event gtag purchase
        window.dataLayer = window.dataLayer || [];

        // combine all subscription IDs and order IDs together for tracking
        let trackedTransactionIds = []
            .concat(window.purchase.checkout.chargebeeSubscriptionIds)
            .concat(window.purchase.checkout.chargebeeInvoiceIds);

        if (!window.customer) {
            console.error('Customer data missing!');
            return;
        }

        // Count how many subscription products the customer already has
        const numberOfExistingSubscriptions =
            window.customer.subscriptions?.objects?.[0]?.items?.length ?? 0;
        const numberOfPurchasedSubscriptions = window.purchase.checkout?.chargebeeSubscriptionIds?.length ?? 0;
        const hasEndedPurchasedSubscriptions =
            window.customer.subscriptions.hasEndedBodySubscription() ||
            window.customer.subscriptions.hasEndedDayScriptSubscription() ||
            window.customer.subscriptions.hasEndedNightCreamSubscription();
        // Check if the purchase contains atleast one subscription items
        const hasPurchasedSubscriptionItem =
            window.purchase.hasPurchasedSubscription();

        let customerType;
        if (
            hasPurchasedSubscriptionItem &&
            numberOfExistingSubscriptions === numberOfPurchasedSubscriptions
        ) {
            customerType = hasEndedPurchasedSubscriptions
                ? 'existing_with_past_subscription'
                : 'new_subscriber';
        } else if (numberOfExistingSubscriptions > 0) {
            customerType = 'existing_subscriber';
        } else if (hasEndedPurchasedSubscriptions) {
            customerType = 'existing_with_past_subscription';
        } else {
            customerType = 'non_subscriber';
        }

        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: trackedTransactionIds.join('|'),
                affiliation: 'Online Store',
                value: finalTotal,
                currency: 'GBP',
                coupons: window.purchase.coupons.map(function (coupon) {
                    return coupon.code;
                }),
                customer_type: customerType,
                purchase_types: window.purchase.getPurchaseTypes(),
                items: window.purchase.items.map(function (item) {
                    let product = item.getProduct();

                    return {
                        item_id: product.chargebeeAddOnId ?? product.id,
                        item_name: product.name,
                        item_category: product.id,
                        price: product.price,
                        quantity: item.quantity,
                        subscription_length: product.subscription_length,
                    };
                }),
            },
        });

        if (typeof window.tracking.awin !== 'undefined') {
            window.tracking.awin.send(
                finalTotal,
                trackedTransactionIds.join('|'),
                window.purchase.coupons,
                window.customer.id
            );
        }
        // clear the purchase so we don't record it again
        window.purchase.clear();
    });
})(jQuery);

